/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorRfqTaskListCriteria } from '../../models/vendor-rfq-task-list-criteria';
import { VendorRfqTaskListResultItem } from '../../models/vendor-rfq-task-list-result-item';

export interface ApiVendorTasklistVendorRfqTaskListPost$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
      body?: VendorRfqTaskListCriteria
}

export function apiVendorTasklistVendorRfqTaskListPost(http: HttpClient, rootUrl: string, params?: ApiVendorTasklistVendorRfqTaskListPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorRfqTaskListResultItem>>> {
  const rb = new RequestBuilder(rootUrl, apiVendorTasklistVendorRfqTaskListPost.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VendorRfqTaskListResultItem>>;
    })
  );
}

apiVendorTasklistVendorRfqTaskListPost.PATH = '/api/vendor/tasklist/VendorRfqTaskList';
